const debounce = (callback, interval = 0) => {
  let prevTimeoutId;
 
  return (...args) => {
    clearTimeout(prevTimeoutId);
    prevTimeoutId = setTimeout(() => callback(...args), interval);
  }
}

class ProgramFilter {
    constructor(container, blockName = 'filter') {
        this.blockName = blockName;
        this.container = container;

        this.modal = document.getElementById('filter-modal');
        this.modalBg = document.getElementById('filter-modal-bg');
        this.openModalBtn = document.getElementById('open-filter-modal');
        this.closeModalBtn = document.getElementById('close-filter-modal');

        this.filterDropdowns = [...this.container.querySelectorAll(`.${this.blockName}__dropdown`)];
        this.cards = [...document.querySelectorAll('.b-program-card')];
        
        // Инициализация каждого фильтра
        this.filters = this.filterDropdowns.map(dropdown =>
            this.initFilter(dropdown)
        );

        this.bindGlobalEvents();
        this.updateFilterButtonText();

        const debounceDelay = 300; //ms
        this.applyFilterInstant = this.applyFilter.bind(this);
        this.applyFilterDebounced = debounce(this.applyFilterInstant, debounceDelay);
    }

    
    // Инициализация одного фильтра 
    initFilter(dropdown) {
        const group = dropdown.dataset.filterGroup; // "location" | "track" | ...
        const button = dropdown.querySelector(`.${this.blockName}__button`);
        const buttonLabel = button.querySelector('span'); 
        const resetBtn = dropdown.querySelector(`.${this.blockName}__reset`);
        const checkboxes = [...dropdown.querySelectorAll(`.${this.blockName}__option input[type="checkbox"]`)];

        // Чекбокс «Выбрать все»
        const allCheckbox = checkboxes.find(cb => cb.dataset.filterAll === 'true') || checkboxes[0];

        // Состояния
        // 1) default — placeholder (начальное состояние) 
        // 2) all — выбраны все чекбоксы
        // 3) custom — несколько, но не все
        dropdown.dataset.selectionState = 'default';

        // запоминаем placeholder из разметки в data-атрибут
        buttonLabel.dataset.placeholder = buttonLabel.dataset.placeholder || buttonLabel.textContent.trim();

        button.addEventListener('click', e => this.toggleDropdown(e, dropdown));
        resetBtn.addEventListener('click', e => this.resetGroup(e, dropdown));
        allCheckbox.addEventListener('click', () => this.handleAllCheckbox(dropdown));
        
        // Остальные чекбоксы
        checkboxes
            .filter(cb => cb !== allCheckbox)
            .forEach(cb => {
                cb.addEventListener('change', () => {
                    this.handleCustomSelection(dropdown);
                });
            });

        return { group, dropdown, button, buttonLabel, checkboxes, allCheckbox };
    }

    // =================== TOGGLE DROPDOWN ===================
    toggleDropdown(e, dropdown) {
        e.stopPropagation();
        const isOpen = dropdown.classList.contains('open');

        if (isOpen) this.handleDropdownClose(dropdown);
        dropdown.classList.toggle('open');

        this.closeOtherDropdowns(dropdown);
    }

    closeOtherDropdowns(current) {
        this.filterDropdowns.forEach(d => {
            if (d !== current && d.classList.contains('open')) {
                this.handleDropdownClose(d);
                d.classList.remove('open');
            }
        });
    }

    resetGroup(e, dropdown) {
        e.preventDefault();
        const { allCheckbox, checkboxes } = this.getFilter(dropdown);
        checkboxes.forEach(cb => (cb.checked = cb === allCheckbox));
        dropdown.dataset.selectionState = 'default';
        this.updateFilterButtonText();
        this.applyFilter();
    }

    
    handleAllCheckbox(dropdown) {
        const { allCheckbox, checkboxes } = this.getFilter(dropdown);
        checkboxes.forEach(cb => cb !== allCheckbox && (cb.checked = false));
        dropdown.dataset.selectionState = 'all';
        this.updateFilterButtonText();

        if (!this.isMobile()) {
            this.applyFilterDebounced();
        }
    }


    handleCustomSelection(dropdown) {
        const { allCheckbox, checkboxes } = this.getFilter(dropdown);
        const checkedOthers = checkboxes.filter(cb => cb !== allCheckbox && cb.checked);

        allCheckbox.checked = checkedOthers.length === 0;
        dropdown.dataset.selectionState = checkedOthers.length > 0 ? 'custom' : 'default';

        this.updateFilterButtonText();

        if (!this.isMobile()) {
            this.applyFilterDebounced();
        }
    }

    handleDropdownClose(dropdown) {
        const { allCheckbox, checkboxes } = this.getFilter(dropdown);
        const others = checkboxes.filter(cb => cb !== allCheckbox);
        const checkedOthers = others.filter(cb => cb.checked);

        if (checkedOthers.length === others.length) {
            allCheckbox.checked = true;
            others.forEach(cb => (cb.checked = false));
            dropdown.dataset.selectionState = 'all';
        }

        this.updateFilterButtonText();
    }
    
    // =================== BUTTON TEXT ===================
    updateFilterButtonText() {
        this.filters.forEach(filter => {
            const { dropdown, buttonLabel, allCheckbox, checkboxes } = filter;
            const state = dropdown.dataset.selectionState;
            const placeholder = buttonLabel.dataset.placeholder;
            const others = checkboxes.filter(cb => cb !== allCheckbox);
            const checkedOthers = others.filter(cb => cb.checked);

            if (state === 'default') {
                buttonLabel.textContent = placeholder;
                return;
            }
            if (state === 'all') {
                buttonLabel.textContent = `Выбрано: ${allCheckbox.parentElement.textContent.trim()}`;
                return;
            }

            const names = checkedOthers.map(cb => cb.parentElement.textContent.trim());
            if (names.length === 1) {
                buttonLabel.textContent = `Выбрано: `;
            } else {
                buttonLabel.textContent = `Выбрано (${names.length}): `;
            }
            buttonLabel.textContent += `${names.join(', ')}`;
        });
    }

    // =================== APPLY FILTER ===================
    applyFilter() {
        const activeValuesByGroup = {};

        this.filters.forEach(filter => {
            const { group, dropdown, checkboxes, allCheckbox } = filter;
            const isCustom = dropdown.dataset.selectionState === 'custom';

            if (!isCustom) {
                activeValuesByGroup[group] = null; // не фильтруем по этой группе
                return;
            }
            
            const selected = checkboxes.filter(cb => cb !== allCheckbox && cb.checked);
            activeValuesByGroup[group] = selected.map(cb => cb.value.trim());
        });

        this.cards.forEach(card => {
            let visible = true;

            this.filters.forEach(filter => {
                if (!visible) return;

                const group = filter.group;
                const values = activeValuesByGroup[group];

                if (!values) return;

                const cardValue = (card.dataset[group] || '').trim();
                if (!values.includes(cardValue)) {
                    visible = false;
                }
            });

            card.hidden = !visible;
        });
    }

    // =================== GLOBAL ===================
    bindGlobalEvents() {
        // Клик вне дропдаунов — закрываем их
        document.addEventListener('click', e => {
            this.filterDropdowns.forEach(dropdown => {
                if (!dropdown.contains(e.target) && dropdown.classList.contains('open')) {
                    this.handleDropdownClose(dropdown);
                    dropdown.classList.remove('open');
                }
            });
        });

        // Мобайл модалка
        this.openModalBtn.addEventListener('click', () => this.openModal());
        this.closeModalBtn.addEventListener('click', () => this.closeModal());
        this.modalBg.addEventListener('click', () => this.closeModal());

        // Кнопка "Применить" внизу модалки (одна на все фильтры)
        const modalApply = this.container.querySelector(`.${this.blockName}__apply--modal`);
        modalApply.addEventListener('click', e => {
            e.preventDefault();
            // при применении через мобайл считаем, что все дропдауны "закрылись"
            this.filterDropdowns.forEach(dropdown => this.handleDropdownClose(dropdown));
            this.applyFilter();
            this.closeModal();
        });
    }

    isMobile() {
        return window.matchMedia('(max-width: 768px)').matches;
    }

    getFilter(dropdown) {
        return this.filters.find(f => f.dropdown === dropdown);
    }

    openModal() {
        this.modal.classList.add('open');
        this.modalBg.classList.add('open');
    }

    closeModal() {
        this.modal.classList.remove('open');
        this.modalBg.classList.remove('open');
    }
}
